/**
 * Suggest an editable market name from the selected country set, in the UI locale.
 * "Poland" / "Poland, Italy" / "Poland, Italy, France" / "Poland +3".
 */
export function suggestMarketName(countries: readonly string[], locale: string): string {
  if (countries.length === 0) return '';

  let displayNames: Intl.DisplayNames | null = null;
  try {
    displayNames = new Intl.DisplayNames([locale], { type: 'region' });
  } catch {
    displayNames = new Intl.DisplayNames(['en'], { type: 'region' });
  }
  const names = countries.map((code) => displayNames?.of(code) ?? code);

  if (names.length <= 3) return names.join(', ');
  return `${names[0]} +${names.length - 1}`;
}
